import Select, { createFilter } from 'react-select';
import styled from 'styled-components';
import { border, darkText, primaryBlue, primaryRed } from '../models/colors';
import type { IStateType } from '../types';
import { isEmpty } from '../utils';

const customStyles = {
	control: (styles: any) => ({
		...styles,
		minHeight: 56,
		boxShadow: 'none',
		border: `2px solid ${border}`,
		backgroundColor: 'transparent',
		'&:hover': {
			borderColor: `#000`,
		},
		'&:active, &:focus': {
			borderColor: primaryBlue,
		},
	}),
	singleValue: (styles: any) => ({ ...styles, color: darkText, fontFamily: "'Roboto', sans-serif" }),
	placeholder: (styles: any) => ({ ...styles, fontFamily: "'Roboto', sans-serif" }),
	option: (styles: any) => ({ ...styles, height: 56, display: 'flex', alignItems: 'center' }),
	menu: (styles: any) => ({ ...styles, zIndex: 2 }),
};

const TypeaheadContainer = styled('div')`
	display: flex;
	margin-top: -24px;
	margin-bottom: 24px;
	flex-direction: column;
`;
const TypeaheadLabel = styled('label')`
	color: ${border};
	font-size: 0.75rem;
	display: inline-flex;
	padding: 4px 4px 4px 16px;
	font-family: 'Roboto', sans-serif;
	&:[data-label:'helper']: {
		color: ${primaryRed};
	}
`;
const TypeaheadSection = styled('div')`
	width: 100%;
`;

export const StyledTypeahead = ({
	name,
	value,
	label,
	options,
	placeholder,
	helperText,
	onChange,
	onBlur,
	style,
	...rest
}: any) => {
	const fieldValue = isEmpty(value)
		? ''
		: options.find((op: { index: string; value: string; label: string }) => op.value === value);

	return (
		<TypeaheadContainer style={style}>
			<TypeaheadSection>
				<TypeaheadLabel htmlFor={name}>{label}</TypeaheadLabel>
			</TypeaheadSection>
			<TypeaheadSection>
				<Select
					id={name}
					value={fieldValue}
					options={options}
					styles={customStyles}
					placeholder={placeholder}
					onChange={(v: IStateType) => onChange?.(name, v.value)}
					onBlur={() => onBlur?.(name, true)}
					filterOption={createFilter({ matchFrom: 'start' })}
					{...rest}
				/>
			</TypeaheadSection>
			<TypeaheadSection>
				<TypeaheadLabel data-label="helper">{helperText || ' '}</TypeaheadLabel>
			</TypeaheadSection>
		</TypeaheadContainer>
	);
};
